import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import TopView from '@/views/TopView.vue'
import OAuthLinkView from '@/views/OAuthLinkView.vue'
import UpdatePassword from '@/views/update-password/UpdatePassword.vue'
import UpdateInitialPassword from '@/views/update-password/UpdateInitialPassword.vue'
import AccountingPeriod from '@/views/AccountingPeriod.vue'
import CorporationInfo from '@/views/corporation-info/CorporationInfo.vue'
import ClearCache from '@/views/ClearCache.vue'

export const commonRoute: RouteRecordRaw = {
  path: '/',
  component: BaseLayoutView,
  children: [
    { path: 'top', component: TopView },
    { path: 'period', component: AccountingPeriod },
    { path: 'corporation-info', component: CorporationInfo },
    { path: 'update-password', component: UpdatePassword },
    { path: 'update-initial-password', component: UpdateInitialPassword },
    { path: 'link-oauth', component: OAuthLinkView },
    { path: 'clear-cache', component: ClearCache }
  ]
}
